<template>
  <div>
    <base-header class="pb-6" />
    <b-container fluid class="mt--6 max-width">
      <b-card no-body>

        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
          <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">


            <card-header title="Edit Device">
              <base-button type="white" size="sm" @click="onCancel">Cancel</base-button>
              <base-button type="success" size="sm" native-type="submit" :loading="isLoading">Save</base-button>
            </card-header>

            <b-card-body>
              <b-row>
                <b-col md="6">
                  <base-input label="Device ID" name="name" v-model="form.name" :rules="{required: true, devicename: true}" />
                </b-col>
                <b-col md="6">
                  <base-input label="Description" name="description" v-model="form.description"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <fieldset>
                    <label class="form-control-label">Groups <span class="font-weight-light">Optional</span></label>
                    <dispenser-select :selected.sync="form.group"/>
                  </fieldset>
                </b-col>
              </b-row>

                           <!-- LoRa checkbox -->
              <div class="mt-4 mb-2">
                <div class="pl-4">
                  <b-form-checkbox
                    v-model="addToLora"
                    :disabled="!loraAvailable || isLoading"
                    switch
                  >
                    Add this device to LoRa / TTN
                  </b-form-checkbox>
                </div>
                <small v-if="!loraAvailable" class="text-muted ml-5">
                  <i class="fas fa-info-circle mr-1"></i>
                  {{ loraUnavailableReason }}
                </small>
              </div>

              <!-- LoRa settings, only when checkbox is on -->
              <div v-if="addToLora" class="border rounded p-3 mt-3">
                <h6 class="mb-3">
                  <i class="fas fa-broadcast-tower mr-1"></i>
                  LoRa settings
                </h6>

                <b-row>
                  <b-col md="6">
                    <b-form-group label="DevEUI (16 hex)">
                      <b-form-input
                        v-model.trim="form.dev_eui"
                        :placeholder="suggestedDevEui || 'auto from Device ID'"
                        :disabled="isLoading || devEuiLocked"
                      />
                      <small class="text-muted d-block">
                        Auto-generated from Device ID.
                        <a
                          v-if="suggestedDevEui && form.dev_eui !== suggestedDevEui && !devEuiLocked"
                          href="#"
                          @click.prevent="form.dev_eui = suggestedDevEui"
                        >Use default ({{ suggestedDevEui }})</a>
                        <span v-else-if="!suggestedDevEui">
                          Enter a valid 12-hex Device ID first, or type DevEUI manually.
                        </span>
                      </small>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="JoinEUI (16 hex)">
                      <b-form-input
                        v-model.trim="form.join_eui"
                        :placeholder="defaultJoinEui"
                        :disabled="isLoading"
                      />
                      <small class="text-muted">
                        Default <code>{{ defaultJoinEui }}</code>. Override only if your device requires a different JoinEUI.
                      </small>
                    </b-form-group>
                  </b-col>
                </b-row>

                                <b-form-group label="AppKey (32 hex)">
                  <b-input-group>
                    <b-form-input
                      v-model="form.app_key"
                      :type="showApiKey ? 'text' : 'password'"
                      placeholder="00112233445566778899aabbccddeeff"
                      autocomplete="new-password"
                      :disabled="isLoading"
                    />
                    <b-input-group-append>
                      <b-button
                        variant="outline-secondary"
                        :disabled="isLoading"
                        @click="showApiKey = !showApiKey"
                      >
                        <i :class="showApiKey ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-muted">
                    Root key. Pre-filled with a default for testing. Stored encrypted.
                  </small>
                </b-form-group>

                <b-row>
                  <b-col md="6">
                    <b-form-group label="Frequency plan">
                      <b-form-select
                        v-model="form.frequency_plan_id"
                        :options="frequencyPlanOptions"
                        :disabled="isLoading"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="LoRaWAN version">
                      <b-form-select
                        v-model="form.lorawan_selection"
                        :options="lorawanVersionOptions"
                        :disabled="isLoading"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-form-checkbox v-model="form.supports_class_c" :disabled="isLoading">
                  Device supports Class C (continuous receive)
                </b-form-checkbox>
              </div>

              <!--b-row>
                <b-col md="3">
                  <base-input label="Lora DevEUI" name="lora_deveui" v-model="form.lora_deveui" :rules="{lora_deveui: true}" />
                </b-col>

                <b-col md="3">
                  <base-input label="LTE IMSI" name="lte_imsi" v-model="form.lte_imsi" :rules="{lte_imsi: true}" />
                </b-col>

                <b-col md="3">
                  <base-input label="Version ID" name="version" v-model="form.version_id" :rules="{}" />
                </b-col>

                <b-col md="3">
                  <base-input label="Manufacturing Type" name="serial" v-model="form.manufacturing_type" disabled />
                </b-col>

              </b-row>

              <b-row>

                <b-col md="12">
                  <label class="form-control-label">X509 Certificate <span class="font-weight-light">Optional</span></label>
                  <textarea class="form-control mb-2 font-mono" rows="2" v-model="form.cert" readonly></textarea>
                  <file-loader
                      initialLabel="Select Certificate file (.pem, .pub)"
                      accept=".pem,.pub"
                      :maxSize="100000"
                      :content.sync="form.cert" />
                </b-col>

              </b-row>-->

            </b-card-body>

          </b-form>
        </validation-observer>

      </b-card>
    </b-container>
  </div>
</template>



<script>
import {Routes} from "@/router";
import {Action} from "@/store/actions";
import {mapGetters} from "vuex";
import {MapServiceDevice} from "@/services/map.service";
import DispenserSelect from "../../views/components/DispenserSelect.vue";

const DEFAULT_JOIN_EUI = "38b8ebe000000001";
const DEVICE_ID_HEX = /^[0-9a-f]{12}$/i;

export default {
  name: "DeviceEdit",
  components: {
    DispenserSelect
  },
  data() {
    return {
      form: {
        name: '',
        description: '',
        manufacturing_type: 'CC2',
        lora_deveui: '',    // mac_1
        lte_imsi: '',       // mac_2
        version_id: '',
        group:'',
        last_dispenser: undefined,
        cert: undefined,
        // LoRa / TTN
        dev_eui: "",
        join_eui: DEFAULT_JOIN_EUI,
        app_key: "00112233445566778899aabbccddeeff",
        frequency_plan_id: "EU_863_870_TTN",
        lorawan_selection: "MAC_V1_0_2|PHY_V1_0_2_REV_B",
        supports_class_c: true,
      },
      activeDevice: '',
      isLoading: false,
      addToLora: false,
      wasLora: false,
      showApiKey: false,
      defaultJoinEui: DEFAULT_JOIN_EUI,
      frequencyPlanOptions: [
        { value: "EU_863_870_TTN",   text: "EU_863_870_TTN (Europe)" },
        { value: "US_902_928_FSB_2", text: "US_902_928_FSB_2 (North America)" },
        { value: "AU_915_928_FSB_2", text: "AU_915_928_FSB_2 (Australia)" },
      ],
      lorawanVersionOptions: [
         { value: "MAC_V1_0_2|PHY_V1_0_2_REV_B", text: "LoRaWAN 1.0.2" },
        { value: "MAC_V1_0_3|PHY_V1_0_3_REV_A", text: "LoRaWAN 1.0.3" },
       
      ],
    };
  },
  computed: {
    ...mapGetters(['deviceByName']),
    activeEntity() {
      return this.$store.getters.activeEntity;
    },
    loraIntegration() {
      return this.$store.getters.ttnIntegration(this.activeEntity);
    },
    loraAvailable() {
      return !!(this.loraIntegration && this.loraIntegration.status === "ok");
    },
    loraUnavailableReason() {
      if (!this.loraIntegration) {
        return "This entity has no TTN integration yet. Configure it in Entity settings first.";
      }
      return `TTN integration status is '${this.loraIntegration.status}'. Fix and re-test it in Entity settings first.`;
    },
    suggestedDevEui() {
      const n = (this.form.name || "").toLowerCase();
      if (!DEVICE_ID_HEX.test(n)) return "";
      return n.slice(0, 7) + "0" + "0000" + n.slice(-4);
    },
    devEuiLocked() {
      return this.addToLora && this.wasLora && !this.loraAvailable;
    },
  },
  methods: {
    onCancel() {
      this.$router.push({name: Routes.deviceList});
    },
    loraFormValid() {
      const hex = (s, n) =>
        typeof s === "string" &&
        new RegExp(`^[0-9a-f]{${n}}$`, "i").test(s);
      return (
        hex(this.form.dev_eui, 16) &&
        hex(this.form.join_eui, 16) &&
        (hex(this.form.app_key, 32) || (this.wasLora && !this.form.app_key))
      );
    },
    async onSubmit() {
      if (!this.form.name) return;

      if (this.addToLora && !this.loraFormValid()) {
        this.$notify({
          type: "warning",
          title: "Missing LoRa fields",
          text: "Fill DevEUI (16 hex), JoinEUI (16 hex) and AppKey (32 hex) before saving.",
        });
        return;
      }

      this.isLoading = true;
      const wasLora = this.wasLora;
      const nowLora = this.addToLora;

      try {
        const model = MapServiceDevice.formToModel(this.form);

        if (nowLora) {
          // Device is or becomes LoRa: save with LoRa fields
          const [mac, phy] = this.form.lorawan_selection.split("|");
          Object.assign(model, {
            transport: "lora",
            provider: "ttn",
            dev_eui: (this.form.dev_eui || "").toLowerCase(),
            join_eui: (this.form.join_eui || this.defaultJoinEui).toLowerCase(),
            frequency_plan_id: this.form.frequency_plan_id,
            lorawan_version: mac,
            lorawan_phy_version: phy,
            supports_class_c: !!this.form.supports_class_c,
            provision_status: "pending",
          });
          if (this.form.app_key) {
            model.app_key = this.form.app_key;
          } else {
            delete model.app_key; // keep existing encrypted key
          }
        } else {
          // Not LoRa (or being detached): strip LoRa fields
          ["transport", "provider", "provider_device_id", "dev_eui", "join_eui",
           "app_key", "frequency_plan_id", "lorawan_version", "lorawan_phy_version",
           "supports_class_c", "provision_status", "provision_detail"]
            .forEach((k) => delete model[k]);
        }

        await this.$store.dispatch(Action.device.save, {
          name: this.activeDevice,
          data: model,
        });

        if (wasLora && !nowLora) {
          // Detach after saving non-LoRa changes
          try {
            await this.$store.dispatch(Action.ttn.deviceDetach, {
              entity: this.activeEntity,
              name: this.activeDevice,
            });
            this.$notify({
              type: "success",
              title: "Detached",
              text: "LoRa removed and device deprovisioned from TTN.",
            });
          } catch (err) {
            const msg =
              (err && (err.message || err.provision_detail)) ||
              "Detach failed.";
            this.$notify({
              type: "warning",
              title: "Save ok, TTN detach failed",
              text: `${msg} Fix the TTN link and try again.`,
            });
          }
        } else if (nowLora) {
          // Provision or re-provision
          try {
            await this.$store.dispatch(Action.ttn.deviceProvision, {
              entity: this.activeEntity,
              name: this.activeDevice,
            });
            this.$notify({
              type: "success",
              title: "Saved",
              text: "Device updated and provisioned in TTN.",
            });
          } catch (err) {
            const msg =
              (err && (err.message || err.provision_detail)) ||
              "Provisioning failed.";
            this.$notify({
              type: "warning",
              title: "Saved, TTN provisioning failed",
              text: `${msg} Retry from the device list.`,
            });
          }
        } else {
          this.$notify({ type: "success", title: "Saved", text: "Device updated." });
        }

        this.$router.push({ name: Routes.deviceList });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Save failed",
          text:
            (error && (error.message || JSON.stringify(error))) ||
            "Unknown error",
        });
        this.isLoading = false;
      }
    }
  },
  mounted() {
    const name = this.$route.params.name
    if(!name) { this.$router.back(); return }
    const device = this.deviceByName(name)
    if(!device) { this.$router.back(); return }
    this.activeDevice = name;
    this.form = MapServiceDevice.modelToForm(device, this.form)

    // Make sure the TTN integration status is loaded
    if (this.activeEntity) {
      this.$store.dispatch(Action.ttn.load, this.activeEntity).catch(() => {});
    }

    // Pre-fill LoRa state from the stored device
    this.wasLora = device.transport === "lora";
    this.addToLora = this.wasLora;
    if (this.wasLora) {
      this.form.dev_eui = device.dev_eui || "";
      this.form.join_eui = device.join_eui || DEFAULT_JOIN_EUI;
      this.form.frequency_plan_id = device.frequency_plan_id || "EU_863_870_TTN";
      this.form.supports_class_c = !!device.supports_class_c;
      if (device.lorawan_version && device.lorawan_phy_version) {
        this.form.lorawan_selection = `${device.lorawan_version}|${device.lorawan_phy_version}`;
      }
      this.form.app_key = ""; // never populated; blank keeps the existing key
    }
  },
}
</script>